import React from 'react'
import Gap from './Gap'

export interface UserStatisticInfoProps {
  reviewCount: number
  followerCount: number
  followingCount: number
  onReviewClick?: () => void
  onFollowerClick?: () => void
  onFollowingClick?: () => void
}

/**
 * 프로필 위쪽의 세 숫자 — 기록 / 팔로워 / 팔로잉.
 *
 * 라벨을 바깥에서 바꾸지 못하게 한다. 예전에는 reviewLabel prop 이 있어서
 * 내 프로필만 '경험한 장소', 남의 프로필은 '기록' 이라고 **같은 숫자를 서로
 * 다르게** 부르고 있었다. 부를 이름이 화면마다 달라질 이유가 없다.
 */
const UserStatisticInfo: React.FC<UserStatisticInfoProps> = ({
  reviewCount,
  followerCount,
  followingCount,
  onReviewClick,
  onFollowerClick,
  onFollowingClick,
}) => {
  const renderStatisticItem = (
    label: string,
    count: number,
    onClick?: () => void
  ) => {
    return (
      <div
        className={`flex-1 flex flex-col items-center ${onClick ? 'cursor-pointer' : ''}`}
        onClick={onClick}
      >
        <div className="font-pretendard font-700 text-18px leading-125% text-brown-80%-main text-center">
          {count}
        </div>
        <Gap height={4} />
        <div className="font-pretendard font-regular text-14px leading-24px text-textColorText3 text-center">
          {label}
        </div>
      </div>
    )
  }

  return (
    <div className="w-full flex items-center justify-center">
      {renderStatisticItem('기록', reviewCount, onReviewClick)}
      <div className="w-1px h-25px bg-brandPrimary-20%"></div>
      {renderStatisticItem('팔로워', followerCount, onFollowerClick)}
      <div className="w-1px h-25px bg-brandPrimary-20%"></div>
      {renderStatisticItem('팔로잉', followingCount, onFollowingClick)}
    </div>
  )
}

export default UserStatisticInfo
